import { observer } from 'mobx-react-lite'
import { Navigate, Outlet } from 'react-router'
import { useEffect, useMemo } from 'react'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { IntegrationsAccessStore } from 'pages/settings/pages/integrations/store/IntegrationsAccessStore'

export const IntegrationsAccessLayout = observer(() => {
  const entities = useEntitiesContext()
  const { userPermissionsStore } = entities
  const store = useMemo(() => new IntegrationsAccessStore(entities), [])
  const { can_manage_integrations } = userPermissionsStore

  useEffect(() => {
    store.init()
  }, [])

  if (store.loading) {
    return <SpinnerLoader ariaLabel={'IntegrationsAccessLayout'} />
  }

  if (!can_manage_integrations) {
    return <Navigate to={'/'} replace />
  }

  return (
    <>
      <Outlet />
    </>
  )
})
